import React from "react";
import PropTypes from "prop-types";

const InputDefinitionList = props => {
  const { label, definition, name, isValid = true, toolTip } = props;
  const styles = toolTip ? tooltipStyles : noTooltipStyles;

  const style = {
    ...styles.label,
    ...(isValid ? {} : { color: "red" }),
  };
  return (
    <dl style={styles.dl}>
      <dt>
        <label style={style} htmlFor={name}>
          {label}
        </label>
        {toolTip}
      </dt>
      <dd>{definition}</dd>
    </dl>
  );
};

InputDefinitionList.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  name: PropTypes.string,
  definition: PropTypes.any,
  isValid: PropTypes.bool,
  toolTip: PropTypes.any,
};

const noTooltipStyles = {
  dl: {
    marginBottom: "1rem",
  },
  label: {
    display: "block",
    color: "#444444",
    marginBottom: "0.3em",
    fontWeight: "bold",
  },
};

const tooltipStyles = {
  ...noTooltipStyles,
  label: { display: "inline-block", marginRight: "0.3em" },
};

export default InputDefinitionList;
